export const allowedDebugIps = ["86.92.188.1"];

export function isDebugEnabled() {
    return localStorage.getItem("debug") === "true";
}

export function debugLog(log: any): void {
    if (isDebugEnabled()) {
        console.log(log);
    }
}

export function disabledWebsocketEvent(event: string): boolean {
    return isDebugEnabled() && localStorage.getItem(`disabledWebsocketEvent_${event}`) === "true";
}

export function disableComponentPart(componentPart: string): boolean {
    return isDebugEnabled() && localStorage.getItem(`disabledComponentPart_${componentPart}`) === "true";
}
